import React, { useEffect, useState } from "react";
import { getStreakStats } from "../../data/streakRepo";
import { useAuth } from "../../context/AuthContext";
import { BsFire } from "react-icons/bs";
import { AiOutlineFire, AiFillFire } from "react-icons/ai";
import "./StreakWidget.css";

export default function StreakWidget() {
  const { user } = useAuth();
  const [streakData, setStreakData] = useState(null);

  const diasSemana = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SAB"];

  useEffect(() => {
    if (!user?.uid) return;

    async function fetchStreak() {
      try {
        const data = await getStreakStats({ uid: user.uid });
        if (data) setStreakData(data);
      } catch (err) {
        console.error("Erro ao buscar streak:", err);
      }
    }

    fetchStreak();
  }, [user]);

  if (!streakData) return null;

  const { currentStreak, longestStreak, streakHistory } = streakData;

  // Gerar 7 dias com o dia atual no centro
  const hoje = new Date();
  const dias = [];
  for (let i = -3; i <= 3; i++) {
    const d = new Date();
    d.setDate(hoje.getDate() + i);
    const key = d.toISOString().split("T")[0];
    dias.push({
      label: diasSemana[d.getDay()],
      active: streakHistory?.[key],
      isToday: i === 0,
      date: d.getDate(),
    });
  }


  return (
    <div className="streak-card">
        <div className="streak-header-row">
            <div className="streak-main">
                <BsFire className="streak-icon" />
                <span className="streak-number">
                {currentStreak} <span className="streak-label">dias seguidos</span>
                </span>
            </div>

            <span className="streak-best">Recorde: {longestStreak}</span>
        </div>


      <div className="streak-week">
        {dias.map((d, i) => (
          <div
            key={i}
            className={`streak-day ${d.isToday ? "today" : ""}`}
            title={d.label}
          >
            <span className="streak-day-label">{d.label}</span>
            {d.active ? (
              <BsFire className="streak-fire filled" size={20} />
            ) : (
              <BsFire className="streak-fire empty" size={20} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
